module.exports = __webpack_public_path__ + "static/is-emri-planlamasi-171aae4aeccf379624ad75d8019cd7f3.svg";